export const PLAYER_SHIP_CLASSES = ['fighter', 'dart', 'gunship', 'longbow', 'warden'] as const;

export type PlayerShipClass = typeof PLAYER_SHIP_CLASSES[number];

export interface PlayerShipInfo {
  name: string;
  description: string;
  color: string;
}

export const PLAYER_SHIP_INFO: Record<PlayerShipClass, PlayerShipInfo> = {
  fighter: { name: 'Fighter', description: 'All-rounder with a rapid blaster', color: '#2a7fff' },
  dart: { name: 'Dart', description: 'Fast interceptor with a short-range repeater', color: '#33d6ff' },
  gunship: { name: 'Gunship', description: 'Slow and tough, fires three-bolt spreads', color: '#4a5cff' },
  longbow: { name: 'Longbow', description: 'Long-range sniper cannon, fragile hull', color: '#8a7dff' },
  warden: { name: 'Warden', description: 'Recharges nearby shields, heavy point defense', color: '#35e0d0' },
};

/** The level at which each class can first be built at the mothership. */
export const SHIP_UNLOCK_LEVEL: Record<PlayerShipClass, number> = {
  fighter: 1, dart: 2, gunship: 3, longbow: 4, warden: 5,
};

/** Classes the shipyard can build once the player has reached `level`. */
export function unlockedShipClasses(level: number): PlayerShipClass[] {
  return PLAYER_SHIP_CLASSES.filter(cls => SHIP_UNLOCK_LEVEL[cls] <= level);
}
